export const fileAcceptTypes = '.jpeg,.jpg,.png,.pdf'

export const aclOptionEnums = {
  private: 'PRIVATE',
  publicRead: 'PUBLIC_READ'
}

export const aclOptions = {
  private: 'private',
  publicRead: 'public-read',
  publicReadWrite: 'public-read-write',
  authenticatedRead: 'authenticated-read',
  bucketOwnerRead: 'bucket-owner-read',
  bucketOwnerFullControl: 'bucket-owner-full-control'
}

export const OVER_RIDE_BUCKET_PATH = ''

export const EXTRA_BUCKET_PATH = ''
